import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';




import { LanguageService } from '../internal/language-service';
//import { Absence, Sighting } from '../../models/models';
//import { environment } from '@env/environment';
import { EventService } from '../internal/event-service';
import { Sighting } from '@spotter/models/sighting';
import { Absence } from '@spotter/models/absence';
import { ReactionType } from '@spotter/models/base-sighting';
//import { AuthService } from './auth-service';




//  export interface User {
//      username: string;
//  }

/** The explore sighting service that deals with getting and modifying sightings */
@Injectable({ providedIn: 'root' })
export class ExploreService {
	//currentUser: User;

	sightings: Array<Sighting>;
	absences: Array<Absence>;

	filteredSightings:  Array<Sighting> = [];

	//env = environment;

	/** The constructor */
	constructor(public http: HttpClient, private lang: LanguageService, public events: EventService)
	{
		this.sightings = new Array<Sighting>();
		this.absences = new Array<Absence>();
	}



    /** Gets a sighting for an ID number
     *  @return an observable with the sighting data
     */
	public getSighting(idNumber: number): Observable<Sighting>
    {
		return new Observable(observer => {

			let urlParams = new HttpParams().set('nearby', true);

            this.http.get<Sighting>("/api/sighting/" + idNumber, {params: urlParams})
            .subscribe({
                next: (data: Sighting) => {
                    observer.next(data);
                    observer.complete();
                },
                error: (error) => {
                    console.error(error);
                    observer.error("Couldn't get the sighting");
                    observer.complete();
                }
            });
        });
	}



	public getNearby(latitude: number, longitude: number): Promise<Sighting[]>
    {
		return new Promise<Sighting[]>((resolve, reject) => {
            let urlParams = new HttpParams()
                .set('latitude', latitude)
                .set('longitude', longitude);

            this.http.get<Sighting[]>("/api/sighting/nearby", { params: urlParams }).subscribe({
                next: sightings => {
                    resolve(sightings);
                },
                error: (err) => {
                    console.error(err);
                    reject(err);
                }
            })
        });
	}

    public getPreviousSighting(id: number) : Sighting|undefined
    {
        for (let i=1; i<this.sightings.length; i++)
            if (this.sightings[i].id == id)
                return this.sightings[i-1];

        return undefined;
    }

    public getNextSighting(id: number) : Sighting|undefined
    {
        for (let i=0; i<this.sightings.length-1; i++)
            if (this.sightings[i].id == id)
                return this.sightings[i+1];

        return undefined;
    }


	/** Gets all the sightings, in order from newest to oldest
     *  Will either retreive from the API, or return what was loaded in a previous request
     * @return an observable with the sightings data array
     */
	public getSightings(): Observable<Array<Sighting>>
    {
		return new Observable(observer => {
            this.http.get<Array<Sighting>>("/api/sighting")
            .subscribe({
                next: (data: Array<Sighting>) => {
                    this.sightings = data.reverse();
					this.filteredSightings = this.sightings;
					//this.events.sightingsLoaded.emit();
					//this.filter();
                    observer.next(this.sightings);
                    observer.complete();
                },
                error: (error) => {
                    console.error("Unable to get sightings from sighting");
                    console.error(error);
                    observer.error("Couldn't get the sightings");
                    observer.complete();
                }
            });
        });
	}


	/** Gets all the sightings, in order from newest to oldest
     *  Will either retreive from the API, or return what was loaded in a previous request
     * @return an observable with the sightings data array
     */
	public getAbsences(): Observable<Array<Absence>>
    {
		return new Observable(observer => {
            this.http.get<Array<Absence>>("/api/absence")
            .subscribe({
                next: (data: Array<Absence>) => {
                    this.absences = data.reverse();
                    observer.next(this.absences);
                    observer.complete();
                },
                error: (error) => {
                    console.error("Unable to get absences from /absence");
                    console.error(error);
                    observer.error("Couldn't get the absences");
                    observer.complete();
                }
            });
        });
	}



	public getAbsence(idNumber: number): Observable<Absence>
	{
		let urlParams = new HttpParams().set('nearby', true);

		return new Observable(observer => {
			this.http.get<Absence>("/api/absence/" + idNumber, {params: urlParams})
			.subscribe({
				next: (data: Absence) => {
					observer.next(data);
					observer.complete();
                    console.log(data);
                    
				},
				error: (error) => {
					console.error(error);
					observer.error("Couldn't get the absence");
					observer.complete();
				}
			});
		});
	}


	/** Adds a new sighting to the array */
	public addNewSighting(sighting: Sighting)
	{
		this.sightings.unshift(sighting);
    }

	/** Adds a new absence to the array */
	public addNewAbsence(absence: Absence)
	{
		this.absences.unshift(absence);
    }



}
